import classNames from 'classnames';
import React from 'react';
import { BaseOperateView, BaseStagePlugin, useFramework, useSelectedInfoKey } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import groupInnerPickPlugin from './group-inner-pick-plugin';
import pickPlugin from './pick-plugin';

// 选中图层信息
const SelectedPlugin = React.memo(() => {
    const framework = useFramework();

    useSelectedInfoKey();
    const selectedInfo = framework.operate.getSelectedInfo();

    if (!selectedInfo || !selectedInfo.size) return null;
    const arrIds = Array.from(selectedInfo);

    return (
        <BaseStagePlugin originIndexOrLayerId={arrIds[0]} name="render-pick-layer">
            {arrIds.map((id) => {
                const layer = framework.getLayer(id);
                const checkIsGroup = framework.checkIsGroup(layer);
                return (
                    <BaseOperateView key={id} layer={layer}>
                        <div
                            className={classNames('makeup-pick-layer', {
                                'is-group': checkIsGroup,
                            })}
                        ></div>
                    </BaseOperateView>
                );
            })}
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 1,
    name: 'render-pick-layer',
    render() {
        return <SelectedPlugin />;
    },
    dependencies() {
        return [{ plugin: groupInnerPickPlugin }, { plugin: pickPlugin }];
    },
};

export default exportPlugin;
